import { SelectOption } from '../../types';
import { AddEditMatterFormData } from '../types';
import { NativeSelect } from '@mantine/core';
import { Form } from '../types';
import styles from '../sharedStyles/InputField.module.css';
import { getInputPropsSafe, Paths } from '@/utils/getInputPropsSafe';

const SelectField = ({
  fieldName,
  label,
  options,
  form,
  ...props
}: {
  fieldName: Paths<AddEditMatterFormData>;
  label: string;
  options: SelectOption[];
  form: Form;
}) => {
  return (
    <NativeSelect
      className={styles.inputField}
      label={label}
      data={options}
      {...getInputPropsSafe(form, fieldName)}
      {...props}
    />
  );
};

export default SelectField;
